export default __webpack_public_path__ + "static/main-secondary01-a339ae74ef0cba1a5fdfc6837e98d187.jpg";